// _app/immutable/assets/11.478fa175.css
export default ".heading.svelte-117fmts{color:#15181c;font-size:3rem}\n";